import type { FooterContent } from './types';
import { EXTERNAL_LINKS } from './externalLinks';

export const footerContent: FooterContent = {
  logo: 'Color Scales I/O',
  mission: 'Design accessible color scales in seconds—without leaving your flow.',
  copyright: `© ${new Date().getFullYear()} Color Scales I/O`,
  navGroups: [
    {
      title: 'Product',
      links: [
        {
          text: 'Open plugin in Figma',
          href: 'https://www.figma.com/community/plugin/1564367214330636618/color-scales-i-o',
          isExternal: true,
        },
      ],
    },
    {
      title: 'Contact',
      links: [
        { text: 'info@colorscales.io', href: 'mailto:info@colorscales.io', isExternal: false },
      ],
    },
  ],
  finePrint: {
    firstLine: [
      'Powered by ',
      {
        text: 'Adobe Leonardo',
        href: EXTERNAL_LINKS.leonardo,
        external: true,
        wrap: 'ins',
      },
      '. ',
    ],
    secondLine: 'Not affiliated with Adobe or Figma.',
    className: 'hide--tablet-and-up'
  }
};

